"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function ox(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6435 18.7504H11.3565C10.3905 18.7504 10.1168 17.8549 10.1168 17.1709C10.1168 16.4869 10.1655 16.1771 10.1655 15.8681C10.1655 15.3806 9.9195 14.1634 9.47325 13.6534C8.604 12.6596 8.0565 11.7694 8.0565 10.4779C7.3005 10.0871 5.964 9.72863 5.4495 9.14288C4.935 8.55713 4.5 7.72538 4.5 6.53588C4.5 6.23213 4.5645 5.80313 4.6935 5.24963C4.98975 6.17513 5.44575 6.80963 6.0615 7.15463C6.96225 7.66013 7.97775 8.03438 8.8455 8.03438H15.1545C16.0222 8.03438 17.037 7.65938 17.9385 7.15463C18.5535 6.80963 19.0103 6.17513 19.3065 5.24963C19.4355 5.80313 19.5 6.23213 19.5 6.53588C19.5 7.72463 19.065 8.55563 18.5505 9.14138C18.036 9.72713 16.6995 10.0864 15.9435 10.4764C15.9435 11.7686 15.396 12.6589 14.5267 13.6526C14.0805 14.1626 13.8345 15.3799 13.8345 15.8674C13.8345 16.1764 13.8832 16.4861 13.8832 17.1701C13.8832 17.8541 13.6095 18.7496 12.6435 18.7496V18.7504Z", fill: color }));
}
exports["default"] = ox;
//# sourceMappingURL=ox.js.map